import {getQuery} from "@/modules/common/utils";

const baseUrl = 'professions';

const searchProfession = (searchValue, locale) => getQuery(`${baseUrl}/search`, {search: searchValue, locale});

export default {
  searchProfession
}
